<template>
  <div class="calico-tiers-table-dialog-page">
    <button
      class="button-primary"
      @click="open = true"
    >
      Open Tiers Table
    </button>
    <TiersTableDialog
      v-if="open"
      @close="open = false"
    />
  </div>
</template>

<script>
import TiersTableDialog from '@/components/pattern/tiersTableDialog/index.vue'

export default {
  name: 'CalicoTiersTableDialogPage',
  components: { TiersTableDialog },
  data: () => ({
    open: true
  })
}
</script>

<style lang="scss">
.template-tiers-table-dialog-page {
  width: 100%;
  height: 100vh;
  background: rgb(103, 100, 100);
  @include inset-space($space-medium);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
